export const EmailController = () => {

  $('.js-newsletter-form').each((index, element) => {
    var emailInput;
  
    $(".js-email-input").on("change", function () {
      emailInput = $(this).val();
      if (validateEmail(emailInput)) {
        $(this).css({
          border: "1px solid #d9d7d7"
        });
      } else {
        $(this).css({
          color: "red",
          border: "1px solid red"
        });
        $('.js-error').show();
      }
    });

    $('#newsletter').submit(function(e) {

        e.preventDefault(); // avoid to execute the actual submit of the form.
    
        var form = $(this);
        var input = $('.js-email-input').val();
        var url = form.attr('action');

        if (!validateEmail(input)) {
            $('.js-error').show();
            return;
        }
        else {
            $('.js-error').hide();
        }

        $.ajax({
               type: "POST",
               url: url,
               data: form.serialize(), // serializes the form's elements.
               success: function(data)
               {
                   var data =  JSON.parse(data);
                  
                   if (data.error){ // (data.error).toLowerCase().indexOf("yes") >= 0
                        if ((data.error.msg).toLowerCase().indexOf("duplicate_parameter") >= 0) {
                            $('.js-error').hide();
                            $('.js-error-other').hide();
                            $('.js-error-exist').show();
                        }
                        else {
                            $('.js-error-exist').hide();
                            $('.js-error').hide();
                            $('.js-error-other').show();
                        }
                   }
                   else { 
                    form.hide();
                        $('.js-error-exist').hide();
                        $('.js-error').hide();
                        $('.js-error-other').hide();
                        $('.js-success').show();
                   }

               },
              
             });
        });
  


    function validateEmail(email) {
      var pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return $.trim(email).match(pattern) ? true : false;
    }

  })

}


// WEBPACK FOOTER //
// ./src/js/controllers/EmailController.js